import { FieldShell } from '@today/ui-components'
import { Input } from '@today/ui-primitives'
import type { ReactElement } from 'react'

/** A labelled text input whose error is linked to it (shared by the compliance forms). */
export function TextInput({
	label,
	value,
	error,
	type = 'text',
	onChange,
}: {
	label: string
	value: string
	error?: string
	type?: 'text' | 'number'
	onChange: (value: string) => void
}): ReactElement {
	return (
		<FieldShell label={label} error={error}>
			<Input type={type} value={value} onChange={(e) => onChange(e.target.value)} />
		</FieldShell>
	)
}

/** A form-level refusal, announced to assistive technology. */
export function FormAlert({ message }: { message: string | null }): ReactElement | null {
	return message ? (
		<p role="alert" className="text-ds-sm text-ds-danger">
			{message}
		</p>
	) : null
}
